import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { useScheduleNavigator } from "@/hooks/useScheduleNavigator";
import { useTrackEvent } from "@/utils/Analytics/Mixpanel/hooks/useTrackEvent";
import { DepartmentIcon } from "@whoosh/design-system/src/components/icons_v2/department";
import {
  Text,
  Pressable,
  VStack,
} from "@whoosh/design-system/src/components/primitive";
import { useTodaysDate } from "@whoosh/utilities/src/dates";

import { DepartmentCard_department$key } from "./__generated__/DepartmentCard_department.graphql";

type Props = {
  departmentRef: DepartmentCard_department$key | null;
};
export const DepartmentCard = ({ departmentRef }: Props) => {
  const department = useFragment(DepartmentCardFragmentString, departmentRef);
  const trackEvent = useTrackEvent();
  const curDate = useTodaysDate();
  const navigateToSchedule = useScheduleNavigator();

  return department ? (
    <VStack>
      <Pressable
        onPress={() => {
          navigateToSchedule("department", department.slug, curDate);
          trackEvent("Homepage.BookTodayDepartmentCTAClicked", {
            departmentSlug: department?.slug,
          });
        }}
      >
        <VStack
          bg="surface-primary"
          borderColor="surface-main-primary-subtle"
          borderWidth={2}
          width={96}
          height={96}
          justifyContent="center"
          alignItems="center"
          borderRadius="4"
          flexDirection="column"
          gap={3}
        >
          <DepartmentIcon type={department.type} />
          <Text
            maxFontSizeMultiplier={1.25}
            variant="mainSmallSemiBold"
            textAlign="center"
          >
            {department.name}
          </Text>
        </VStack>
      </Pressable>
    </VStack>
  ) : null;
};

const DepartmentCardFragmentString = graphql`
  fragment DepartmentCard_department on Department {
    id
    name
    slug
    type
  }
`;
